// extracted by mini-css-extract-plugin
export default {"container":"pq-z","brandName":"qq-z","productName":"rq-z","productNamePdpEnhancements":"sq-z","breakLongProductName":"tq-z"};